// extracted by mini-css-extract-plugin
export default {"userLink":"userLink--ujaeT","small":"small--s7qZP","large":"large--WEASG","avatar":"avatar--iVr68"};